// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/app_settings/custom_attributes_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomAttributesData } from "./constants";
import type { AppSettingsCustomAttributesDataParams, AppSettingsCustomAttributesDataResult } from "./types";
import { isAppSettingsCustomAttributeDataResult } from "./validators";

export const getDataTableAppSettingsCustomAttributesData = reactQueryTableFetcherAdapter(
  appSettingsCustomAttributesData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      includeNested,
      limitedTypes,
    }: AppSettingsCustomAttributesDataParams
  ): Promise<AppSettingsCustomAttributesDataResult> => {
    return fetch(
      "/app_settings/custom_attributes_data",
      "GET",
      {
        include_nested: includeNested,
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        limited_types: limitedTypes,
      },
      { signal }
    );
  },
  isAppSettingsCustomAttributeDataResult
);
